import luxembourgLogoImg from '@/assets/vectors/branding/luxembourg-logo.svg';
import { MINERVA_WEBSITE_URL } from '@/constants';
import { closeDrawer, openDrawer } from '@/redux/drawer/drawer.slice';
import { useAppDispatch } from '@/redux/hooks/useAppDispatch';
import { closeLegend, openLegend } from '@/redux/legend/legend.slice';
import { openPluginsDrawer } from '@/redux/plugins/plugins.slice';
import { IconButton } from '@/shared/IconButton';
import { store } from '@/redux/store';

import Image from 'next/image';

export const NavBar = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const toggleDrawerInfo = (): void => {
    if (store.getState().drawer.isOpen && store.getState().drawer.drawerName === 'project-info') {
      dispatch(closeDrawer());
    } else {
      dispatch(openDrawer('project-info'));
    }
  };

  const toggleDrawerPlugins = (): void => {
    if (
      store.getState().drawer.isOpen &&
      store.getState().drawer.drawerName === 'available-plugins'
    ) {
      dispatch(closeDrawer());
    } else {
      dispatch(openDrawer('available-plugins'));
    }
    dispatch(openPluginsDrawer());
  };

  const toggleDrawerExport = (): void => {
    if (store.getState().drawer.isOpen && store.getState().drawer.drawerName === 'export') {
      dispatch(closeDrawer());
    } else {
      dispatch(openDrawer('export'));
    }
  };

  const toggleDrawerLayers = (): void => {
    if (store.getState().drawer.isOpen && store.getState().drawer.drawerName === 'layers') {
      dispatch(closeDrawer());
    } else {
      dispatch(openDrawer('layers'));
    }
  };

  const toggleDrawerLegend = (): void => {
    if (store.getState().legend.isOpen) {
      dispatch(closeLegend());
    } else {
      dispatch(openLegend());
    }
  };

  const configuration = store.getState().configuration.main.data;
  const version = configuration ? `(v${configuration.version})` : '';

  const constant = store.getState().constant.main.data;

  const apiDocsUrl = constant ? constant.apiDocsUrl : '';

  return (
    <div className="flex min-h-full w-[88px] flex-col items-center justify-between overflow-y-auto bg-cultured py-8">
      <div data-testid="nav-buttons" className="w-full">
        <div className="mb-8 flex w-full flex-col gap-[5px]">
          <div>
            <div className="flex flex-row items-center justify-center">
              <IconButton icon="info" onClick={toggleDrawerInfo} title="Project info" />
            </div>
            <span className="relative -top-2 block text-center text-[10px]">Project info</span>
          </div>
          <div>
            <div className="flex flex-row items-center justify-center">
              <IconButton icon="plugin" onClick={toggleDrawerPlugins} title="Available plugins" />
            </div>
            <span className="relative -top-2 block text-center text-[10px]">Plugins</span>
          </div>
          <div>
            <div className="flex flex-row items-center justify-center">
              <IconButton icon="export" onClick={toggleDrawerExport} title="Export" />
            </div>
            <span className="relative -top-2 block text-center text-[10px]">Export</span>
          </div>
          <div>
            <div className="flex flex-row items-center justify-center">
              <IconButton icon="layers" onClick={toggleDrawerLayers} title="Layers" />
            </div>
            <span className="relative -top-2 block text-center text-[10px]">Layers</span>
          </div>
        </div>
        <div className="flex flex-col gap-[5px]">
          <div>
            <div className="flex flex-row items-center justify-center">
              <a href={apiDocsUrl} target="_blank">
                <IconButton icon="page" title="API Doc" />
              </a>
            </div>
            <span className="relative -top-2 block text-center text-[10px]">API</span>
          </div>
          <div className="flex flex-row items-center justify-center">
            <IconButton icon="legend" onClick={toggleDrawerLegend} title="Legend" />
          </div>
          <span className="relative -top-5 block text-center text-[10px]">Legend</span>
        </div>
      </div>
      <div
        className="mx-2 flex flex-col items-center gap-[20px] "
        data-testid="nav-logos-and-powered-by"
      >
        <a href="https://www.uni.lu/en/" target="_blank">
          <Image
            className="rounded rounded-e rounded-s bg-white-pearl pb-[7px]"
            src={luxembourgLogoImg}
            alt="University of Luxembourg logo"
            height={41}
            width={48}
          />
        </a>
        <span className="h-16 w-[4.5rem] text-center text-[10px] leading-4">
          <a href={MINERVA_WEBSITE_URL} target="_blank" className="text-blue-800">
            Powered by: <b>the MINERVA Platform {version}</b>
          </a>
        </span>
      </div>
    </div>
  );
};
